import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => {
  return {
    colorPickerContent: {
      padding: '8px'
    },
    buttonContainer: {
      marginTop: '8px'
    },
    button: {
      flex: 1
    },
    emojiPickerContainer: {
      width: '350px'
    },
    sourceCodeTextarea: {
      fontFamily: 'monospace',
      fontSize: '12px'
    },
    headingSelect: {
      width: 'fit-content',
      maxWidth: '120px'
    },
    fontFamilySelect: {
      width: 'fit-content',
      minWidth: '120px',
      maxWidth: '120px'
    },
    editorContent: {
      '& .tiptap': {
        minHeight: '400px',
        padding: '12px'
      },
      '& .ProseMirror': {
        '& ul[data-type="taskList"]': {
          listStyle: 'none !important',
          marginLeft: '0 !important',
          padding: '0 !important',
          '& li': {
            alignItems: 'flex-start',
            display: 'flex !important',
            listStyle: 'none !important',
            '& > label': {
              flex: '0 0 auto',
              marginRight: '0.5rem !important',
              userSelect: 'none'
            },
            '& > div': {
              flex: '1 1 auto'
            }
          },
          '& input[type="checkbox"]': {
            cursor: 'pointer'
          },
          '& ul[data-type="taskList"]': {
            margin: '0 !important'
          },
          '& p': {
            margin: 0
          }
        },
        '& blockquote': {
          borderLeft: '4px solid #d1d5db',
          paddingLeft: '16px',
          marginLeft: 0,
          marginRight: 0,
          marginTop: '16px',
          marginBottom: '16px',
          color: '#6b7280',
          fontStyle: 'italic',
          backgroundColor: '#f9fafb',
          paddingTop: '12px',
          paddingBottom: '12px',
          paddingRight: '16px',
          borderRadius: '4px'
        },
        '& img': {
          maxWidth: '100%',
          height: 'auto',
          cursor: 'pointer',
          transition: 'opacity 0.2s',
          '&.editor-image': {
            display: 'block',
            margin: '16px auto',
            '&:hover': {
              opacity: 0.9,
              outline: '2px solid #1890ff',
              outlineOffset: '2px'
            }
          }
        },
        '& iframe': {
          maxWidth: '100%',
          display: 'block',
          margin: '16px auto'
        },
        '& table': {
          borderCollapse: 'collapse',
          tableLayout: 'fixed',
          width: '100%',
          margin: '16px 0',
          overflow: 'hidden',
          '& td, & th': {
            minWidth: '1em',
            border: '1px solid #d1d5db',
            padding: '8px 12px',
            verticalAlign: 'top',
            boxSizing: 'border-box',
            position: 'relative',
            '& > *': {
              marginBottom: 0
            }
          },
          '& th': {
            fontWeight: 600,
            textAlign: 'left',
            backgroundColor: '#f9fafb'
          },
          '& .selectedCell:after': {
            zIndex: 2,
            position: 'absolute',
            content: '""',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            background: 'rgba(200, 200, 255, 0.4)',
            pointerEvents: 'none'
          },
          '& .column-resize-handle': {
            position: 'absolute',
            right: '-2px',
            top: 0,
            bottom: '-2px',
            width: '4px',
            backgroundColor: '#adf',
            pointerEvents: 'none'
          }
        },
        '& .tableWrapper': {
          margin: '16px 0',
          overflowX: 'auto'
        },
        '& .resize-cursor': {
          cursor: 'col-resize'
        }
      }
    }
  }
})
